// import necessary modules
import {Navigate} from 'react-router-dom'
import BinaryRain from './BinaryRain';

//import asset files
import headshot from "../../assetFiles/myPhoto.png"
import oliverLogo from "../../assetFiles/oliver_agency_logo.jpg"
import resumePdf from "../../assetFiles/Steven Huang [Resume].pdf"
import resumeImage from "../../assetFiles/resume_image.png"

// import css styling
import './Home.css'

function HomePage() {
    return (
        <>
            <div style={{ width: '100vw'}}>
                <BinaryRain 
                    myImage= {headshot}
                    myHeader= "Hi! I'm Steven, a product manager and developer."
                    myText= "A fourth-year student at Columbia University studying computer science."

                    experienceHeader = 'Most Recent Role'
                    experienceImage = {oliverLogo}
                    experienceDesc = 'AI Product Intern at OLIVER Agency, NYC'

                    resumeHeader='Resume'
                    isPdf = {true}
                    pdfLink={resumePdf}
                    pdfText="Steven's Resume"
                    pdfPreview={resumeImage}
                />
            </div>
        </>
    );
}

export default HomePage